import { render, staticRenderFns } from "./DistributionBoardView.vue?vue&type=template&id=0c501add"
import script from "./DistributionBoardView.vue?vue&type=script&lang=js"
export * from "./DistributionBoardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports